export default {
    getLabTableIsShow: state => state.labTableShow,
    getLabFormIsShow: state => state.labFormShow,
    getPatientLabTableIsShow: state => state.patientLabTableShow,
    getPatientLabFormIsShow: state => state.patientLabFormShow,

    getLabTableActions: state => state.labTableActions,
    getLabTableRowActions: state => state.labTableRowActions,
    getLabTableSearchFields: state => state.labTableSearchFields,
    getPatientLabTableSearchFields: state => state.patientLabTableSearchFields,
    getLabTableAdditionalConfig: state => state.labTableAdditionalConfig,
    getLabTableHeaderFields: state => state.labTableHeaderFields,

    getLabFormFields: state => state.labFormFields,

    getPatientLabTableHeaderFields: state => state.patientLabTableHeaderFields,
    getPatientLabTableRowActions: state => state.patientLabTableRowActions,
    getPatientLabTableRowActionsViewOnly: state => state.patientLabTableRowActionsViewOnly,

    getEditLabFormActions: state => state.editLabFormActions,
    getEditLabFormFields: state => state.editLabFormFields,

    getPatientDetailsLabTableRowActions: state => state.patientDetailsLabTableRowActions,

    getDataTableOptions: state => state.dataTableOptions,
}